import RegisterPartnerJsSerializer from './-json-api';

export default class KycSerializer extends RegisterPartnerJsSerializer {}
